// Service card for the Shop · Services list. Different shape from product card:
// shows partner badge, duration tiers and a "Book" CTA instead of "+ to cart".
import { useNavigate } from 'react-router-dom';

const fmtINR = (n) =>
  n == null
    ? null
    : new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      }).format(n);

export default function ServiceCard({ service, index }) {
  const navigate = useNavigate();
  const variants = service.variants || [];
  const minPrice = service.base_price;
  const isOnRequest = service.combo_only || minPrice == null || minPrice === 0;

  return (
    <div
      data-testid={`service-card-${index}`}
      onClick={() => navigate(`/shop/services/${service.id}`)}
      className="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100 cursor-pointer transition-transform active:scale-[0.98]"
    >
      <div className="relative">
        {service.images?.[0] && (
          <img
            data-testid={`service-image-${service.id}`}
            src={service.images[0]}
            alt={service.name}
            className="w-full h-36 object-cover"
            referrerPolicy="no-referrer"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        )}
        {service.partner_brand && (
          <span
            data-testid={`service-partner-${service.id}`}
            className="absolute top-2 left-2 bg-[#2B3A67] text-white text-[10px] font-black px-2 py-1 rounded-full uppercase tracking-wider"
          >
            {service.partner_brand}
          </span>
        )}
        {isOnRequest && (
          <span
            data-testid={`service-on-request-${service.id}`}
            className="absolute top-2 right-2 bg-[#F4D341] text-[#2B3A67] text-[10px] font-black px-2 py-1 rounded-full"
          >
            ON REQUEST
          </span>
        )}
      </div>

      <div className="p-4">
        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
          {service.service_category}
        </p>
        <h3
          data-testid={`service-name-${service.id}`}
          className="font-bold text-sm mt-1 mb-2 line-clamp-2"
        >
          {service.name}
        </h3>

        <div className="flex flex-wrap gap-1 mb-3">
          {variants.slice(0, 3).map((v) => (
            <span
              key={v.id}
              className="text-[10px] font-bold text-[#2B3A67] bg-gray-100 px-2 py-0.5 rounded-full"
            >
              {v.duration_minutes}m
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between">
          {isOnRequest ? (
            <span
              data-testid={`service-price-${service.id}`}
              className="font-black text-[#E54562] text-xs"
            >
              Enquire
            </span>
          ) : (
            <span
              data-testid={`service-price-${service.id}`}
              className="font-black text-[#E54562] text-sm"
            >
              from {fmtINR(minPrice)}
            </span>
          )}
          <button
            className="text-[10px] font-extrabold uppercase tracking-wider text-white bg-[#2B3A67] px-3 py-2 rounded-full"
            data-testid={`service-book-${service.id}`}
          >
            {isOnRequest ? 'Enquire' : 'Book'}
          </button>
        </div>
      </div>
    </div>
  );
}
